export const CLOUD = {
  COMPUTING: {
    FILTER_cloud_service_computing: 'FILTER_cloud_service_computing',
    GRIDCOLUMNS_cloud_computing_resourceList: 'GRIDCOLUMNS_cloud_computing_resourceList',
    FILTERSEARCH_cloud_computing: 'FILTERSEARCH_cloud_computing',
  },
  STORAGE: {
    FILTER_cloud_service_storage: 'FILTER_cloud_service_storage',
    GRIDCOLUMNS_cloud_storage_resourceList: 'GRIDCOLUMNS_cloud_storage_resourceList',
    FILTERSEARCH_cloud_storage: 'FILTERSEARCH_cloud_storage',
  },
  DATABASE: {
    FILTER_cloud_service_database: 'FILTER_cloud_service_database',
    GRIDCOLUMNS_cloud_database_resourceList: 'GRIDCOLUMNS_cloud_database_resourceList',
    FILTERSEARCH_cloud_database: 'FILTERSEARCH_cloud_database',
  },
  CLOUD_SERVICE_DETAIL: {
    TAB_cloud_cloudServiceDetail_selected: 'TAB_cloud_cloudServiceDetail_selected',
    METRIC_cloud_service_detail_metricChart: 'METRIC_cloud_service_detail_metricChart',
    METRIC_cloud_service_detail_metricChart_timePeriod:
      'METRIC_cloud_service_detail_metricChart_timePeriod',
    GRIDCOLUMNS_cloud_service_detail_awsAlarm: 'GRIDCOLUMNS_cloud_service_detail_awsAlarm',
    FILTERSEARCH_cloud_service_detail_awsAlarm: 'FILTERSEARCH_cloud_service_detail_awsAlarm',
    GRIDCOLUMNS_cloud_service_detail_awsAlarm_elasticache:
      'GRIDCOLUMNS_cloud_service_detail_awsAlarm_elasticache',
    FILTERSEARCH_cloud_service_detail_awsAlarm_elasticache:
      'FILTERSEARCH_cloud_service_detail_awsAlarm_elasticache',

    GRIDCOLUMNS_cloud_service_detail_azureAlarm: 'GRIDCOLUMNS_cloud_service_detail_azureAlarm',
    FILTERSEARCH_cloud_service_detail_azureAlarm: 'FILTERSEARCH_cloud_service_detail_azureAlarm',
    TOGGLE_cloud_cloudServiceDetail_info_expanded: 'TOGGLE_cloud_cloudServiceDetail_info_expanded',
    TOGGLE_cloud_dmsTaskDetail_connectionTopology_expanded:
      'TOGGLE_cloud_dmsTaskDetail_connectionTopology_expanded',
  },
  AWS: {
    EC2: {
      GRIDCOLUMNS_cloud_aws_ec2_instanceList: 'GRIDCOLUMNS_cloud_aws_ec2_instanceList',
      FILTER_cloud_aws_ec2: 'FILTER_cloud_aws_ec2',
      FILTERSEARCH_cloud_aws_ec2: 'FILTERSEARCH_cloud_aws_ec2',

      GRIDCOLUMNS_cloud_aws_detail_ec2_awsAlarm: 'GRIDCOLUMNS_cloud_aws_detail_ec2_awsAlarm',
      FILTERSEARCH_cloud_aws_detail_ec2_awsAlarm: 'FILTERSEARCH_cloud_aws_detail_ec2_awsAlarm',

      METRIC_cloud_aws_awsView_awsDetail_ec2_metricChart:
        'METRIC_cloud_aws_awsView_awsDetail_ec2_metricChart',
      METRIC_cloud_aws_awsView_awsDetail_ec2_metricChart_timePeriod:
        'METRIC_cloud_aws_awsView_awsDetail_ec2_metricChart_timePeriod',
    },

    LAMBDA: {
      GRIDCOLUMNS_cloud_aws_lambda_functionList: 'GRIDCOLUMNS_cloud_aws_lambda_functionList',
      FILTER_cloud_aws_lambda: 'FILTER_cloud_aws_lambda',
      FILTERSEARCH_cloud_aws_lambda: 'FILTERSEARCH_cloud_aws_lambda',

      GRIDCOLUMNS_cloud_aws_detail_lambda_awsAlarm: 'GRIDCOLUMNS_cloud_aws_detail_lambda_awsAlarm',
      FILTERSEARCH_cloud_aws_detail_lambda_awsAlarm:
        'FILTERSEARCH_cloud_aws_detail_lambda_awsAlarm',

      METRIC_cloud_aws_awsView_awsDetail_lambda_metricChart:
        'METRIC_cloud_aws_awsView_awsDetail_lambda_metricChart',
      METRIC_cloud_aws_awsView_awsDetail_lambda_metricChart_timePeriod:
        'METRIC_cloud_aws_awsView_awsDetail_lambda_metricChart_timePeriod',
    },

    S3: {
      GRIDCOLUMNS_cloud_aws_s3_bucketList: 'GRIDCOLUMNS_cloud_aws_s3_bucketList',
      FILTER_cloud_aws_s3: 'FILTER_cloud_aws_s3',
      FILTERSEARCH_cloud_aws_s3: 'FILTERSEARCH_cloud_aws_s3',

      GRIDCOLUMNS_cloud_aws_detail_s3_awsAlarm: 'GRIDCOLUMNS_cloud_aws_detail_s3_awsAlarm',
      FILTERSEARCH_cloud_aws_detail_s3_awsAlarm: 'FILTERSEARCH_cloud_aws_detail_s3_awsAlarm',

      METRIC_cloud_aws_awsView_awsDetail_s3_metricChart:
        'METRIC_cloud_aws_awsView_awsDetail_s3_metricChart',
      METRIC_cloud_aws_awsView_awsDetail_s3_metricChart_timePeriod:
        'METRIC_cloud_aws_awsView_awsDetail_s3_metricChart_timePeriod',
    },

    DOCUMENTDB: {
      GRIDCOLUMNS_cloud_aws_documentDb_clusterList: 'GRIDCOLUMNS_cloud_aws_documentDb_clusterList',
      FILTER_cloud_aws_documentDb: 'FILTER_cloud_aws_documentDb',
      FILTERSEARCH_cloud_aws_documentDb: 'FILTERSEARCH_cloud_aws_documentDb',

      GRIDCOLUMNS_cloud_aws_detail_documentDb_awsAlarm:
        'GRIDCOLUMNS_cloud_aws_detail_documentDb_awsAlarm',
      FILTERSEARCH_cloud_aws_detail_documentDb_awsAlarm:
        'FILTERSEARCH_cloud_aws_detail_documentDb_awsAlarm',

      METRIC_cloud_aws_awsView_awsDetail_documentDb_metricChart:
        'METRIC_cloud_aws_awsView_awsDetail_documentDb_metricChart',
      METRIC_cloud_aws_awsView_awsDetail_documentDb_metricChart_timePeriod:
        'METRIC_cloud_aws_awsView_awsDetail_documentDb_metricChart_timePeriod',
    },
    DMS: {
      GRIDCOLUMNS_cloud_aws_dms_taskList: 'GRIDCOLUMNS_cloud_aws_dms_taskList',
      FILTER_cloud_aws_dms: 'FILTER_cloud_aws_dms',
      FILTERSEARCH_cloud_aws_dms_taskList: 'FILTERSEARCH_cloud_aws_dms_taskList',

      GRIDCOLUMNS_cloud_aws_detail_dms_awsAlarm: 'GRIDCOLUMNS_cloud_aws_detail_dms_awsAlarm',
      FILTERSEARCH_cloud_aws_detail_dms_awsAlarm: 'FILTERSEARCH_cloud_aws_detail_dms_awsAlarm',
      GRIDCOLUMNS_cloud_aws_detail_dms_replication_awsAlarm:
        'GRIDCOLUMNS_cloud_aws_detail_dms_replication_awsAlarm',
      FILTERSEARCH_cloud_aws_detail_dms_replication_awsAlarm:
        'FILTERSEARCH_cloud_aws_detail_dms_replication_awsAlarm',

      METRIC_cloud_aws_awsView_awsDetail_dms_metricChart:
        'METRIC_cloud_aws_awsView_awsDetail_dms_metricChart',
      METRIC_cloud_aws_awsView_awsDetail_dms_replication_metricChart:
        'METRIC_cloud_aws_awsView_awsDetail_dms_replication_metricChart',
      METRIC_cloud_aws_awsView_awsDetail_dms_metricChart_timePeriod:
        'METRIC_cloud_aws_awsView_awsDetail_dms_metricChart_timePeriod',
      METRIC_cloud_aws_awsView_awsDetail_dms_replication_metricChart_timePeriod:
        'METRIC_cloud_aws_awsView_awsDetail_dms_replication_metricChart_timePeriod',
    },

    DYNAMODB: {
      GRIDCOLUMNS_cloud_aws_dynamoDb_tableList: 'GRIDCOLUMNS_cloud_aws_dynamoDb_tableList',
      FILTER_cloud_aws_dynamoDb: 'FILTER_cloud_aws_dynamoDb',
      FILTERSEARCH_cloud_aws_dynamoDb: 'FILTERSEARCH_cloud_aws_dynamoDb',

      GRIDCOLUMNS_cloud_aws_detail_dynamoDb_awsAlarm:
        'GRIDCOLUMNS_cloud_aws_detail_dynamoDb_awsAlarm',
      FILTERSEARCH_cloud_aws_detail_dynamoDb_awsAlarm:
        'FILTERSEARCH_cloud_aws_detail_dynamoDb_awsAlarm',

      METRIC_cloud_aws_awsView_awsDetail_dynamoDb_metricChart:
        'METRIC_cloud_aws_awsView_awsDetail_dynamoDb_metricChart',
      METRIC_cloud_aws_awsView_awsDetail_dynamoDb_metricChart_timePeriod:
        'METRIC_cloud_aws_awsView_awsDetail_dynamoDb_metricChart_timePeriod',
    },

    ELASTICACHE: {
      GRIDCOLUMNS_cloud_aws_elasticache_cacheList: 'GRIDCOLUMNS_cloud_aws_elasticache_cacheList',
      FILTER_cloud_aws_elasticache: 'FILTER_cloud_aws_elasticache',
      FILTERSEARCH_cloud_aws_elasticache: 'FILTERSEARCH_cloud_aws_elasticache',

      GRIDCOLUMNS_cloud_aws_detail_elasticache_shard:
        'GRIDCOLUMNS_cloud_aws_detail_elasticache_shard',
      GRIDCOLUMNS_cloud_aws_detail_elasticache_node:
        'GRIDCOLUMNS_cloud_aws_detail_elasticache_node',
      GRIDCOLUMNS_cloud_aws_detail_elasticache_awsAlarm:
        'GRIDCOLUMNS_cloud_aws_detail_elasticache_awsAlarm',
      FILTERSEARCH_cloud_aws_detail_elasticache_shard:
        'FILTERSEARCH_cloud_aws_detail_elasticache_shard',
      FILTERSEARCH_cloud_aws_detail_elasticache_node:
        'FILTERSEARCH_cloud_aws_detail_elasticache_node',
      FILTERSEARCH_cloud_aws_detail_elasticache_awsAlarm:
        'FILTERSEARCH_cloud_aws_detail_elasticache_awsAlarm',

      METRIC_cloud_aws_awsView_awsDetail_elasticache_metricChart:
        'METRIC_cloud_aws_awsView_awsDetail_elasticache_metricChart',
      METRIC_cloud_aws_awsView_awsDetail_elasticache_serverless_metricChart:
        'METRIC_cloud_aws_awsView_awsDetail_elasticache_serverless_metricChart',
      METRIC_cloud_aws_awsView_awsDetail_elasticache_metricChart_timePeriod:
        'METRIC_cloud_aws_awsView_awsDetail_elasticache_metricChart_timePeriod',
      METRIC_cloud_aws_awsView_awsDetail_elasticache_serverless_metricChart_timePeriod:
        'METRIC_cloud_aws_awsView_awsDetail_elasticache_serverless_metricChart_timePeriod',
    },

    RDS: {
      GRIDCOLUMNS_cloud_aws_rds_databaseList: 'GRIDCOLUMNS_cloud_aws_rds_databaseList',
      FILTER_cloud_aws_rds: 'FILTER_cloud_aws_rds',
      FILTERSEARCH_cloud_aws_rds: 'FILTERSEARCH_cloud_aws_rds',

      GRIDCOLUMNS_cloud_aws_detail_rds_awsAlarm: 'GRIDCOLUMNS_cloud_aws_detail_rds_awsAlarm',
      FILTERSEARCH_cloud_aws_detail_rds_awsAlarm: 'FILTERSEARCH_cloud_aws_detail_rds_awsAlarm',
    },

    REDSHIFT: {
      GRIDCOLUMNS_cloud_aws_redshift_clusterList: 'GRIDCOLUMNS_cloud_aws_redshift_clusterList',
      FILTER_cloud_aws_redshift: 'FILTER_cloud_aws_redshift',
      FILTERSEARCH_cloud_aws_redshift: 'FILTERSEARCH_cloud_aws_redshift',

      GRIDCOLUMNS_cloud_aws_detail_redshift_awsAlarm:
        'GRIDCOLUMNS_cloud_aws_detail_redshift_awsAlarm',
      FILTERSEARCH_cloud_aws_detail_redshift_awsAlarm:
        'FILTERSEARCH_cloud_aws_detail_redshift_awsAlarm',

      METRIC_cloud_aws_awsView_awsDetail_redshift_metricChart:
        'METRIC_cloud_aws_awsView_awsDetail_redshift_metricChart',
      METRIC_cloud_aws_awsView_awsDetail_redshift_metricChart_timePeriod:
        'METRIC_cloud_aws_awsView_awsDetail_redshift_metricChart_timePeriod',
    },

    COST: {
      GRIDCOLUMNS_cloud_aws_costExplorer_instanceList:
        'GRIDCOLUMNS_cloud_aws_costExplorer_instanceList',
      FILTERSEARCH_cloud_aws_costExplorer_instanceList:
        'FILTERSEARCH_cloud_aws_costExplorer_instanceList',
      FILTER_cloud_aws_cost: 'FILTER_cloud_aws_cost',
    },
  },
};
